<template>
  <div class="enquiry-container">
    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             class="tabs">
      <el-tab-pane label="全部货源"
                   name=""
                   class="first"></el-tab-pane>
      <el-tab-pane label="进行中"
                   name="00"></el-tab-pane>
      <el-tab-pane label="已完成"
                   name="01"></el-tab-pane>
      <el-tab-pane label="已失效"
                   name="02"></el-tab-pane>
    </el-tabs>
    <div class="enquiry-search">
      <el-form :inline="true"
               :model="formInline"
               class="search-form-inline "
               label-position="right">
        <span class="imp">出发地</span>
        <el-cascader size="small"
                     class="addressStyle"
                     @active-item-change="handleItemChange"
                     :options="options"
                     v-model="addressFrom"
                     @change="handleChangeFrom">
        </el-cascader>
        <span class="imp">目的地</span>
        <el-cascader size="small"
                     class="addressStyle"
                     :options="options"
                     v-model="addressTo"
                     @active-item-change="handleItemChange"
                     @change="handleChangeTo">
        </el-cascader>
        <el-form-item label="原料"
                      class="material"
                      size="small">
          <el-input v-model="formInline.material"
                    placeholder="请输入原料名称"
                    class="material-name"></el-input>
        </el-form-item>
        <el-form-item class="itembtn"
                      size="small">
          <el-button class="search-submit"
                     type="primary"
                     @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item label="开始时间"
                      size="small">
          <el-date-picker v-model="startDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间"
                      size="small">
          <el-date-picker v-model="endDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="en_main">
      <el-table :data="enquiryInfo.result"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40"
                         fixed>
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         prop="cargoNumber"
                         label="货源编号">
        </el-table-column>
        <el-table-column label="货主信息">
          <template slot-scope="
                         scope">
            <div><span>公司名称：</span>{{scope.row.companyName}}</div>
            <div><span>联系人姓名：</span>{{scope.row.userName}}</div>
            <div><span>联系电话：</span>{{scope.row.userPhone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="位置信息">
          <template slot-scope="scope">
            <div><span>出发地：</span>{{scope.row.startingAddressName}}</div>
            <div><span>目的地：</span>{{scope.row.endAddressName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="货源信息">
          <template slot-scope="scope">
            <div><span>原料：</span>{{scope.row.goodsName}}</div>
            <div><span>重量：</span>{{scope.row.goodsWeight}}吨</div>
            <div><span>询价有效期：</span>{{scope.row.startDate}}至{{scope.row.endDate}}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.cargoStart ==='00'"
                 class="status-style progress">进行中</div>
            <div v-else-if="scope.row.cargoStart ==='01'"
                 class="status-style complated">已完成</div>
            <div v-else-if="scope.row.cargoStart ==='02'"
                 class="status-style failure">已失效</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         min-width="100"
                         align="center">
          <template slot-scope="scope">
            <el-button class="btnc"
                       v-if="scope.row.cargoStart!=='02'"
                       @click="getPriceInfo(scope.row.cargoNumber)">报价详情</el-button>
          </template>

        </el-table-column>

      </el-table>
      <el-dialog title="报价详情"
                 :visible.sync="biddingDetail"
                 class="biddingTable"
                 trigger="click">
        <el-table ref="multipleTable"
                  :data="biddingList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  max-height="491">

          <el-table-column label="报价编号"
                           align="left"
                           min-width="130">
            <template slot-scope="scope">{{scope.row.cargoNumber}}</template>
          </el-table-column>
          <el-table-column label="物流公司"
                           align="left"
                           header-align="center"
                           min-width="135">
            <template slot-scope="scope">
              <div><span>公司名称：</span><span>{{scope.row.logisticsCompanyName}}</span></div>
              <div><span>联系人姓名：</span><span>{{scope.row.logisticsName}}</span></div>
              <div><span>联系电话：</span><span>{{scope.row.logisticsPhone}}</span></div>
            </template>
          </el-table-column>
          <el-table-column label="报价信息"
                           align="left"
                           header-align="center"
                           min-width="165">
            <template slot-scope="scope">
              <div><span>运费报价：</span><span>{{scope.row.freightQuotation}}元/吨</span></div>
              <div><span>车辆总数：</span><span>{{scope.row.tankCarNumber}}辆</span></div>
              <div><span>总核载量：</span><span>{{scope.row.loadTonnage}}吨</span></div>
              <div><span>运费有效期：</span><span>{{scope.row.startDate}}至{{scope.row.endDate}}</span></div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>

    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{enquiryInfo.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="enquiryInfo.pageSize"
                     layout="prev, pager, next"
                     :total="enquiryInfo.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import {
  enquiryList,
  priceInfo,
  provinceList,
  cityList,
  areaList

} from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      activeName: '',
      biddingDetail: false,
      biddingList: [],
      enquiryInfo: {},
      options: [],
      addressFrom: [],
      addressTo: [],
      from: '',
      to: '',
      address: '',
      formInline: {
        material: '',
        from: '',
        to: ''
      },
      startDate: '',
      endDate: '',
      pageNum: 1
    }
  },
  mounted () {
    this.getEnquiryList()
    this.initData()
  },
  methods: {
    getEnquiryList () { // 获取询价货源列表信息
      let statusCode = this.activeName === '0' ? '' : this.activeName
      enquiryList({
        pageNum: this.pageNum,
        cargoStart: statusCode,
        startTime: this.startDate,
        endTime: this.endDate,
        startingAddressName: this.from,
        endAddressName: this.to,
        goodsName: this.formInline.material
      }).then(res => {
        if (res.data.code === 0) {
          this.enquiryInfo = res.data.data.result
        }
      })
    },
    getPriceInfo (item) { // 报价详情
      priceInfo({ cargoNumber: item }).then(res => {
        if (res.data.code === 0) {
          // console.log(res)
          this.biddingDetail = true
          this.biddingList = res.data.data.result
        }
      })
    },
    handleClick () { // table导航条
      // let statusCode = this.activeName === '0' ? '' : this.activeName
      this.formInline = {
        material: ''
      }
      this.addressFrom = []
      this.addressTo = []
      this.startDate = ''
      this.endDate = ''
      this.getEnquiryList()
      // enquiryList({
      //   cargoStart: statusCode
      // }).then(res => {
      //   if (res.data.code === 0) {
      //     this.enquiryInfo = res.data.data.result
      //   }
      // })
    },
    async initData () { // 省市区三级联动
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
        // console.log('11')
      }
    },
    async handleItemChange (val) {
      // console.log('active item:', val)
      // console.log(val)
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
    },
    getAddressText (value) { // 获取地址
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
      // console.log(this.from)
    },
    handleChangeTo (value) {
      this.getAddressText(value)
      this.to = this.address
      // console.log(this.to)
    },
    onSubmit () { // search查询
      this.getEnquiryList()
      // enquiryList({
      //   startTime: this.startDate,
      //   endTime: this.endDate,
      //   startingAddressName: this.from,
      //   endAddressName: this.to,
      //   goodsName: this.formInline.material

      // }).then(res => {
      //   if (res.data.code === 0) {
      //     this.enquiryInfo = res.data.data.result
      //     // console.log(res)
      //   }
      // })
    },
    handleCurrentChange (val) { // 页面切换
      this.pageNum = val
      this.getEnquiryList()
      // enquiryList({ pageNum }).then(res => {
      //   this.enquiryList = res.data.data.result
      // })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.enquiry-container
  height 100%
  background #f7f9fb
  .tabs
    height 51px
    overflow hidden
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px
    .el-tabs__item
      padding 0
      text-align center
      height 51px
      line-height 50px
      width 92px
      size12()
      color #5e656f
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
  .enquiry-search
    margin-top 4px
    padding 0 20px
    .el-table__header-wrapper, .el-form-item
      width 220px
      margin-bottom 10px
      margin-right 24px
      &:nth-last-child(1)
        margin-right 0
    .itembtn
      float right
      margin-right 0
      width auto
    .search-form-inline
      width 100%
      .company-name
        width 146px
        padding 0
        margin 0
      .el-input__inner
        width 146px
        height 28px
        size12()
      .imp
        display inline-block
        width 60px
        color #606266
        text-align right
      .addressStyle
        width 150px
        margin 0 20px 0 10px
        line-height 30px
      .search-submit
        padding 5px 20px
        background #fff
        text-align right
        color $bgColor
        size12()
        &:hover
          background $bgColor
          color #fff
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width 146px
      size12()
    .el-form--inline .el-form-item__label
      width 70px
      size12()
  .en_main
    margin-left 20px
    margin-right 20px
    height calc(100% - 200px)
    overflow hidden
    .el-table
      background #f7f9fb
      width 100%
      height 100%
    .el-table th
      background #e7f0f8
    .el-table td div
      size12()
    .el-table th>.cell
      size12()
    .status-style
      width 40px
      height 40px
      border-radius 50%
      margin 0 auto
      border 1px solid transparent
      size10()
      line-height 40px
      text-align center
    .progress
      progress()
    .complated
      complated()
    .failure
      failure()
    .el-button
      size12()
      margin-top 10px
    .btnc
      btnc()
    .el-button:nth-child(1)
      margin-left 10px
      margin-top 0
    .biddingTable
      .el-dialog
        width auto
        max-width 728px
        .el-dialog__header
          height 42px
          padding 0 20px 0
          background #1b88ee
          .el-dialog__title
            line-height 42px
            font-size 13px
            color #fff
            float left
          .el-dialog__headerbtn
            top 12px
            right 12px
            .el-dialog__close
              color #fff
              font-size 20px
        .el-dialog__body
          padding 15px 20px
          .colorBlue
            color #1b88ee
          .companySelect
            width 180px
            height 30px
            margin 0
            float left
            margin-bottom 20px
            .el-input__inner
              width 145px
              height 30px
            .el-input-group__append
              padding 0
              .el-button
                margin 0
              .el-button--mini, .el-button--mini.is-round
                padding 7px 12px
          .operation
            .el-button
              margin 0
              padding 7px 14px
          .operations
            .el-button
              margin-bottom 0
              padding 7px 27px
          .el-table__expanded-cell
            padding 0
            th
              background #fff
  .pages
    margin 15px 20px 15px 10px
    .demonstartion
      float right
      line-height 45px
      color #5e656f
  .el-table td, .el-table th
    vertical-align top
</style>
